export enum CountriesEnum {
    GERMANY = 'de',
    AUSTRIA = 'at',
    USA = 'us',
    POLAND = 'pl',
    FRANCE = 'fr',
    SPAIN = 'es',
    ITALY = 'it',
    PORTUGAL = 'pt',
    GREECE = 'gr',
    ESTONIA = 'ee',
    RUSSIA = 'ru',
    SWITZERLAND = 'ch',
    CZECH = 'cz',
    UK = 'uk',
    NETHERLANDS = 'nl',
    FINLAND = 'fi',
    DENMARK = 'dk',
    SLOVAKIA = 'sk',
    HUNGARY = 'hu',
    SWEDEN = 'se',
    LATVIA = 'lv',
    BULGARIA = 'bg',
    CANADA = 'ca',
    BELGIUM = 'be',
    AUSTRALIA = 'au',
    ROMANIA = 'ro',
    LITVA = 'lt',
    IZRAEL = 'il',
    IRELAND = 'ie',
    CROATIA = 'hr',
    NEW_ZEALAND = 'nz',
    ARGENTINA = 'ar',
    BRAZIL = 'br',
    TAIWAN = 'tw',
    MEXICO = 'mx',
    JAPAN = 'jp',
    SERBIA = 'rs',
    SINGAPORE = 'sg',
    NORWAY = 'no',
}
